export default __webpack_public_path__ + "static/media/down-arrow-icon.d052b753.svg";